import React from 'react';
import PriceGridItem from "Shared/PriceGridItem";
import BeerService from 'Services/BeerService';
import { dicontainer } from 'DIContainer';

interface IBeerItemProps {
    name: string;
    volumeMl: number;
    numberOfUnits: number;
    bottling: string;
    type: string;
    abv: number;
    country: string;
    price: number;
    thumbnailUrl: string;
}

interface IPriceGridItemState {
    isPricingUnlocked?: boolean;
}

export default class BeerItem extends React.Component<IBeerItemProps, IPriceGridItemState> {
    private _beerService: BeerService = dicontainer.get(BeerService);

    constructor(props: IBeerItemProps) {
        super(props);
        this.state = {
            isPricingUnlocked: this._beerService.isPricingUnlocked
        }
        this.handlePricingUnlocked = this.handlePricingUnlocked.bind(this);
        this.handleShowPriceClick = this.handleShowPriceClick.bind(this);
    }

    public componentDidMount() {
        this._beerService.onPricingUnlocked.addHandler(this.handlePricingUnlocked);
    }

    private handlePricingUnlocked() {
        this.setState({ isPricingUnlocked: true });
    }

    private handleShowPriceClick() {
        this._beerService.showPricingUnlockModal();
    }

    public render() {
        return (
            <PriceGridItem
                title={this.props.name}
                overlayTopLeftText={this.props.abv + '%'}
                overlayBottomText={this.props.numberOfUnits + ' x ' + this.props.volumeMl + ' ml'}
                thumbnailUrl={this.props.thumbnailUrl}
                subtitle={this.props.type + (this.props.country != "Canada" ? (' - ' + this.props.country) : '')}
                mainPriceText={this.props.price.toFixed(2) + '$'}
                otherPriceText1={(this.props.price / this.props.numberOfUnits / this.props.volumeMl * 100).toFixed(2) + '$ / 100 ml'}
                otherPriceText2={(this.props.price / this.props.numberOfUnits).toFixed(2) + '$ / ' + this.props.bottling}
                compactPricing={true}
                lockPricing={!this.state.isPricingUnlocked}
                onShowPriceClick={this.handleShowPriceClick}
            ></PriceGridItem>
        );
    }
}